// export const baseUrl="http://192.168.0.55:9000/";
// export const baseUrl="http://222.211.65.10:9000/";
export const baseUrl="https://www.sckxyy.com/api/";
export const api = {


    /**
     * @deprecated PC端 视图
     * @author 
     */


    'filepath' : baseUrl + "kxuser/user/getConfiguration/imgpath",     //全局附件路径
    'chazhang' : baseUrl + "kxorders/newOrder/chazhang",     //查账


    // 用户登录注册
    "baseUrl" : baseUrl, // 获取API地址
    
    "homeLogin" : baseUrl + "user/login", // 登录
    "generateConnection" : baseUrl + "wx/generateConnection", // 微信扫码获取code
    "getWxUserInfo" : baseUrl + "wx/getOpenUserInfo", // 微信获取openid
    "getWxUserBind" : baseUrl + "user/bind", // 绑定微信账号

    
    "goBencao" : baseUrl + "kxuser/user/beforJumpInsert", // 跳转芸欣
    
    "homeLogout" : baseUrl + "kxuser/user/logout", // 注销账号
    "homeGetOauthConfig" : baseUrl + "kxuser/user/get_oauth_config", // 获取OAUTH
    "homeSMSLogin" : baseUrl + "user/SMSLogin", // 短信登录
    "getUserByPhone" : baseUrl + "user/getUserByPhone", // 根据手机号查询账户
    "homeRegister" : baseUrl + "user/register", // 注册
    "homeForgetPassword" : baseUrl + "user/verifyCode", // 忘记密码
    "homeSendSms" : baseUrl + "user/sendSMS", // 发送短信验证码
    "homeSendEmail" : baseUrl + "kxuser/user/send_email", // 发送邮件

    "homeGetUserInfo" : baseUrl + "user/info/",// 获取用户信息
    "homeEditUserInfo" : baseUrl + "kxuser/user/update/",// 修改用户信息
    "uploadUserAvatar" : baseUrl + "kxuser/user/uploadUserAvatar/",// 上传用户头像
    "uploadUsercertificate" : baseUrl + "kxuser/user/uploadUserAvatar/company/",// 企业资质上传
    "paymentVoucher" : baseUrl + "kxorders/newOrder/paymentVoucher/",// 保存转账凭证
    "LP_xsdcx" : baseUrl + "kxorders/userOrder/LP_xsdcx",  // 两票制查询
    "LP_DownLoad" : baseUrl + "kxorders/userOrder/LP_DownLoad",  // 两票制下载
    "getReferrerList" : baseUrl + "kxuser/user/getReferrerList",  // 用户推广明细



    

    "homeAddUserInfoCompany" : baseUrl + "kxuser/user/create/company",// 添加往来单位
    "homeCheckPayPassword" : baseUrl + "user/check_pay_password",// 验证支付密码

    "homeGetFavList" : baseUrl + "kxgoods/collect/list", // 修改收藏关注列表
    "homeDelFav" : baseUrl + "kxgoods/collect/createOrCancel/", // 删除收藏关注
    

    //用户资金明细
    "homeGetMoneyLog" : baseUrl + "kxuser/account/list",// 获取用户资金变更日志
    "SumAccountMoney" : baseUrl + "kxuser/account/SumAccountMoney",// 账户统计
    
    //上传采购单
    //"homeAvatar" : baseUrl + "kxmarketing/subjects/uploadGoodsGroupImg",// 
    "uploadPurchase" : baseUrl + "kxshopcar/shopCar/uploadExcelToShopCars.do",// 上传采购单
    "uploadQualificationPicture" : baseUrl + "kxuser/user/uploadQualificationPicture/",// 资质上传

    // 邀请信息
    "homeGetInviterInfo" : baseUrl + "kxuser/user/get_inviter_info",// 用户头像上传

    // 认证信息
    "homeGetUserCheckInfo" : baseUrl + "user/get_user_check_info",// 获取用户认证信息
    "homeEditUserCheckInfo" : baseUrl + "user/edit_user_check_info",// 修改用户认证信息
    "homeUserCard" : baseUrl + "user/user_card",// 身份证上传

    // 商城首页接口
    "homeGetSubNavInfo" : baseUrl + "index/get_subnav_info",           // 获取首页左侧导航的信息
    "homeGetIndexInfo" : baseUrl + "index/get_index_info",             // 获取首页信息
    "homeGetFootInfo" : baseUrl + "index/get_foot_info",               // 获取公共底部信息
    "hotGoodsListAll" : baseUrl + "kxmarketing/goodsprom/hotGoodsListAll",         // 热门关键词

    // 秒杀接口
    "homeGetSeckillList" : baseUrl + "seckill/get_seckill_list",       // 获取秒杀

    // 商家入驻
    "homeStoreJoin" : baseUrl + "user/join", 
    "homeGetJoinIndexAdv" : baseUrl + "index/get_join_index_adv", // // 获取加入我们幻灯片
    "homeIsStore" : baseUrl + "store/is_store", // // 获取加入我们幻灯片

    // 商品详情
    "queryGoodsAll" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",                     //商品列表
    "homeGetGoodsInfo" : baseUrl + "kxgoods/goods/get_goods_info",                      //商品详情
    "getGoodsDetails" : baseUrl + "kxgoods/indexGoods/getGoodsDetails/",                //套餐详情
    "getComboList" : baseUrl + "kxgoods/indexGoods/getGoodsDetailsById/",                //当前商品套餐列表
    // "homeSearchGoods" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",                   //商品搜索
    "homeSearchGoods" : baseUrl + "kxes/esProduct/search/",                                  //商品搜索
    "getProductAttribute" : baseUrl + "kxes/esProduct/search/getProductAttribute/",          //商品属性搜索
    "queryDeduplication" : baseUrl + "kxes/esProduct/queryDeduplication/",                   //搜索关键词下拉适配

    "queryGoodsInfoByGoodsId" : baseUrl + "kxgoods/indexGoods/queryGoodsInfoByGoodsId",      //商品详情
    "getGoodsBySpuid" : baseUrl + "kxgoods/indexGoods/getGoodsBySpuid",                     //当前商品下同SPUID商品列表及销量排行
    "homeGetBrandList" : baseUrl + "kxgoods/brand/getList.do",                              //品牌列表
    'homeGetCommentListByGoods' : baseUrl + "kxgoods/goods/get_comment_list_by_goods",      // 获取评论列表根据商品ID



    //首页
    "goodsCategory" : baseUrl + "kxgoods/goodsCategory/listAll",                 //分类
    "productCategory" : baseUrl + "kxgoods/goodsCategory/list/",                 //根据分类ID查子类
    "index_seckill" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",              //限时秒杀
    "best_week" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",                  //本周优选
    "drugstore_sales" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",            //药店热销
    "clinic_sells" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",               //诊所特卖热销
    "newproduct_focus" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",           //新品推荐轮播
    "newproduct_list" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",            //新品推荐
    "recommend_list" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",             //为你推荐
    "control_sales" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",              //为你推荐
    "family_health" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",              //家庭保健
    "tcm_list" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",                   //中医养生
    "household_list" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",             //家用器械
    "apparatus_list" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",             //中医器械
    //"banner_list" : baseUrl + "kxgoods/indexGoods/queryGoodsAll",              //中首页banner

    //新闻
    "getNewTypes" : baseUrl + "kxmarketing/news/getNewTypes.do/",              //新闻分类
    "getNewsList" : baseUrl + "kxmarketing/news/getNewsList.do/",              //新闻列表
    "getItem" : baseUrl + "kxmarketing/news/getItem.do/",                      //新闻详情
    "getHelpCenter" : baseUrl + "kxmarketing/news/getHelpCenter.do",                      //帮助中心分类 


    // 收藏接口
    "homeIsFav" : baseUrl + "kxgoods/collect/createOrCancel/",
    "homeEditFav" : baseUrl + "kxgoods/collect/delete/",

    // 商家首页
    "homeGetStoreInfo" : baseUrl + "store/get_store_info", // 获取商家信息
    "homeGetStoreIndexInfo" : baseUrl + "store/get_store_index_info", // 获取商家首页信息
    "homeGetStoreGoodsClass" : baseUrl + "store/get_store_class", // 获取商家分类信息
    "homeGetStoreClassGoods" : baseUrl + "store/get_store_class_goods", // 获取商家分类信息和商品列表

    // 积分商城
    "homeGetIntegralIndexInfo" : baseUrl + "integral/get_index_info", // 
    "homeGetIntegralGoodsInfo" : baseUrl + "integral/goods/info/", // 获取积分商品详情
    "homeSearchIntegralGoods" : baseUrl + "integral/goods/search_integral_goods", // 获取积分条件列表
    "homeGetIntegralGoodsClass" : baseUrl + "integral/goods/get_integral_goods_class", // 获取积分商品分类

    // 积分商城创建订单
    "homeIntegralCreateOrder" : baseUrl + "integral/order/create_order", // 获取积分商品分类
    "homeGetIntegralUserOrder" : baseUrl + "user/integral/get_user_order", // 获取积分订单
    "homeIntegralChangeOrderStatus" : baseUrl + "user/integral/change_order_status", // 确认收货

    //优惠券
    "getEffectivePromotions" : baseUrl + "kxmarketing/promotion/getEffectivePromotions.do", // 优惠券列表
    "receiveCouponById" : baseUrl + "kxmarketing/promotion/receiveCouponById.do/", // 优惠券领取
    "getGainPromoByUserId" : baseUrl + "kxmarketing/promotion/getGainPromoByUserId.do/", // 用户中心已领取优惠券列表
    "receiveResults" : baseUrl + "kxmarketing/promotion/receiveResults", // 领券结果
    "getDiscountRate" : baseUrl + "kxmarketing/promotion/getDiscountRate", // 折扣率
    




    //团购
    "freeShipping" : baseUrl + "kxmarketing/freeShipping/goods", // 团购
    "shopCarId" : baseUrl + "kxmarketing/freeShipping/shopCarId", // 团购加入购物车

    // 商品销售排行
    "homeGetSaleList" : baseUrl + "goods/get_sale_list",


    // 用户中心
    //"homeGetUserDefault" : baseUrl + "user/get_user_default", // 默认页面
    //订单列表
    "homeGetUserOrder" : baseUrl + "kxorders/userOrder/list", // 默认页面
    //订单明细
    //"cancelOrderDisplay" : baseUrl + "kxorders/userOrder/cancelOrderDisplay/", // 已取消订单列表
    "queryOrderDetailByOrderId" : baseUrl + "kxorders/newOrder/queryOrderDetailByOrderId/", // 订单明细
    "orderCount" : baseUrl + "kxorders/userOrder/listCount/", // 订单统计
    "confirmReceipt" : baseUrl + "kxorders/userOrder/confirmReceipt/", // 确认收货
    "exterfaceInvoke" : "kxorders/userOrder/wlcx/", // 物流查询
    "downzcyj" : baseUrl + "kxorders/userOrder/zcyj", // 注册批件下载
    "joinAgain" : baseUrl + "kxshopcar/shopCar/joinAgain/", // 再次加入购物车
    "invoiceDownload" : baseUrl + "kxorders/userOrder/invoiceDownload", // 查看发票
    "invoiceRequest" : baseUrl + "kxorders/userOrder/invoiceRequest",    // 申请发票
    "getPaymentType" : baseUrl + "kxorders/oderPayment/paymentType",    // 支付方式列表 terminal=3 PC

    "querySconfigInfo" : baseUrl + "kxuser/sconfigInfo/querySconfigInfo/",    // 获取查看订单时间区间




    
    //取消订单
    "getBasedictType" : baseUrl + "kxorders/newOrder/getBasedictType/", // 取消订单原因
    "cancelOrdersByOrderIdToUser" : baseUrl + "kxorders/userOrder/cancelOrdersByOrderIdToUser/",   // 已付款已发货取消订单
    "cancelBeforeReview" : baseUrl + "kxorders/userOrder/cancelBeforeReview",                      // 已付款未发货取消订单
    "cancelOrdersByOrderId" : baseUrl + "kxorders/newOrder/cancelOrdersByOrderId/",                // 未付款取消订单
    "cancelOrderDisplay" : baseUrl + "kxorders/userOrder/cancelOrderDisplay/",                     // 已取消订单列表
    "warehouseExpressUpdate" : baseUrl + "kxorders/newOrder/warehouseExpressUpdate/",              // 售后订单提交退货物流信息
    "getAccompanyingDocumentsTotal" : baseUrl + "kxorders/userOrder/getAccompanyingDocumentsTotal",                                 // 随货同行单
    "outAccompanyingDocumentsDetailsToExcel" : baseUrl + "kxorders/userOrder/outAccompanyingDocumentsDetailsToExcel",              // 随货同行单导出excel
    "outAccompanyingDocumentsDetailsToPDF" : baseUrl + "kxorders/userOrder/outAccompanyingDocumentsDetailsToPDF",                  // 随货同行单导出PDF
    "getAccompanyingDocumentsCounts" : baseUrl + "kxorders/userOrder/getAccompanyingDocumentsCounts",                              // 随货同行单总条数
    "getAccompanyingDocumentsDetails" : baseUrl + "kxorders/userOrder/getAccompanyingDocumentsDetails",                            // 随货同行单详情


    //测试
    'getTestList' : baseUrl + "kxuser/functionTest/getList",   //测试列表
    'createTest' : baseUrl + "kxuser/functionTest/create/",   //创建测试
    'udpateTest' : baseUrl + "kxuser/functionTest/udpate/",   //修改测试
    'deleteTest' : baseUrl + "kxuser/functionTest/deleteFunction/",   //创建测试
    'getFunctionById' : baseUrl + "kxuser/functionTest/getFunctionById/",   //当前ID信息

    //投诉建议
    'getSuggestList' : baseUrl + "kxuser/suggest/suggestList",  
    'createSuggest' : baseUrl + "kxuser/suggest/createSuggest",   
    'updateSuggest' : baseUrl + "kxuser/suggest/updateSuggest",
    

    // 用户收货地址
    'getAddressList' : baseUrl + "kxuser/address/list/",   //获取收货地址列表
    'addAddress' : baseUrl + "kxuser/address/create/",   //添加收货地址
    'editAddress' : baseUrl + "kxuser/address/update/",  //编辑收货地址
    'viewsAddress' : baseUrl + "kxuser/address/getItem/",  //获取当前ID地址信息
    'delAddress' : baseUrl + "kxuser/address/delete/",   //删除收货地址
    'setDefaultAddress' : baseUrl + "kxuser/address/updateAddressStatus/",

    // 获取省市区信息
    "homeGetAreaList" : baseUrl + "kxuser/area/listAll/",
     //"homeGetAreaList" : baseUrl + "kxuser/area/getListByParentId/",


    // 往来单位
    'addUserCompany' : baseUrl + "kxuser/user/create/company",     
    'editUserCompany' : baseUrl + "kxuser/user/update/company/",          //修改往来单位
    'delUserCompany' : baseUrl + "kxuser/user/del/company",
    'listUserCompany' : baseUrl + "kxuser/user/select/company/",
    'getCompanyType' : baseUrl + "kxuser/user/getCompanyType",            //往来单位类别
    //'UserCompanyid' : baseUrl + "kxuser/user/company/",                  //获取当前往来单位ID


    // 公司资质
    'addcertificate' : baseUrl + "kxuser/user/create/certificate",         //添加公司资质
    'certificateid' : baseUrl + "kxuser/user/list/certificate/",           //获取当前ID信息 
    'editcertificate' : baseUrl + "kxuser/user/update/certificate/",       //根据id修改公司资质
    'delcertificate' : baseUrl + "kxuser/user/delete/certificate/",        //删除公司资质      
    'listcertificate' : baseUrl + "kxuser/user/listAll/certificate/",      //查看往来单位所有资质

    //经营范围
    'fetchAllwldwcope' : baseUrl + "kxuser/listAll/",                //当前往来单位下拉选择经营范围
    'fetchListwldwcope' : baseUrl + "kxuser/wldw/listAll/",               //经营范围列表
    'listAllByUserId' : baseUrl + "kxuser/wldw/listAllByUserId/",         //当前往来单位经营范围
    'createJoinUser' : baseUrl + "kxuser/wldw/createJoinUser",            //当前往来单位添加经营范围

    //证件类别
   'getBasedictByType' : baseUrl + "kxuser/new_role/getBasedictByType/",            //证件类别

      



    // 获取物流信息
    'homeGetDeliveryList' : baseUrl + "order/get_user_delivery",
    //获取物流公司信息
    'listExpress' : baseUrl + "kxorders/adminSmallFunctions/listExpress",
    

    // 订单评论
    'homeGetOrderInfoByOrderId' : baseUrl + "order/get_order_info_by_order_id",  // 根据订单ID获取订单信息
    'homeGetCommentList' : baseUrl + "order/get_comment_list",  // 根据订单ID获取订单信息
    'homeAddComment' : baseUrl + "order/add_comment",  // 添加评论
    'homeCommentImage' : baseUrl + "comment/comment_image",  // 图片上传 评论

    // 修改订单状态
    'homeChangeOrderStatus' : baseUrl + "order/change_order_status",
    'homeOrderRefund' : baseUrl + "order/refund", // 申请售后
    'homeOrderRefundDelivery' : baseUrl + "order/refund_delivery_no", // 售后发送快递单号


    // 购物车
    //"homeAddCart" : baseUrl + "cart/add_cart",
    "homeAddCart" : baseUrl + "kxshopcar/shopCar/addShopCars",  //加入购物车
    "homeChangeCart" : baseUrl + "kxshopcar/shopCar/updateShopCarForNumber",  //修改购物车
    "homeDelCart" : baseUrl + "kxshopcar/shopCar/deleteShopCar/",
    "homeGetCartList" : baseUrl + "kxshopcar/shopCar/queryShopCarsDataByLoginUser",  //购物车列表
    "homeGetCartCount" : baseUrl + "kxshopcar/shopCar/getCarCountByUserId",  //购物车数量
    "manualAddNum" : baseUrl + "kxshopcar/shopCar/manualAddNum",  //手动修改购物车数量
    "checkShopCarInfo" : baseUrl + "kxshopcar/shopCar/checkShopCarInfo",  //修改购物车选中状态
    "queryDisCountCouponByShopCar" : baseUrl + "kxmarketing/promotion/queryDisCountCouponByShopCar",  //购物车获取优惠券



    // 预生成订单数据
    'homeGetBeforOrder' : baseUrl + "kxshopcar/shopCar/queryShopCarsDataByLoginUser/",

    // 生成订单
       "beforePlaceOrder" : baseUrl + "kxorders/newOrder/beforePlaceOrder", // 创建订单前加载
       "createOrdersResults" : baseUrl + "kxorders/newOrder/createOrdersResults", // 创建订单返回信息
       'homeCreateOrder' : baseUrl + "kxorders/newOrder/createOrders/",           //生成订单
       "GetFullgift" : baseUrl+"kxmarketing/promotion/queryFullGiftInfo",//根据总金额获取满赠活动
       'GetOrderInfoByOrderNo' : baseUrl + "kxorders/newOrder/queryOrderDetailByOrderId/",  // 根据订单号获取订单信息
       'homePayOrder' : baseUrl + "kxorders/oderPayment/createQRCode/",                     // 扫码聚合支付订单
       'unionpayMoney' : baseUrl + "kxorders/oderPayment/unionpayMoney/",                   // 银联支付
       'transferAccounts' : baseUrl + "kxorders/oderPayment/transferAccounts.do/",          // 线下转账
       'balancePayment' : baseUrl + "kxorders/oderPayment/balancePayment/",                 // 余额支付


       //'getCouponsToOrders' : baseUrl + "kxorders/oderPayment/getCouponsToOrders.do/",  // 根据订单ID获取优惠券列表
       'getCouponsToOrders' : baseUrl + "kxmarketing/promotion/getGainPromoByUserId.do/",  // 根据订单ID获取优惠券列表
       'selectCouponsByGainPromoId' : baseUrl + "kxorders/oderPayment/selectCouponsByGainPromoId.do", // 选择优惠券

      'chinaumsNotify' :  baseUrl + "kxorders/oderPayment/verifyChinaums/", //扫码回调 
      // 'chinaumsNotify' :  baseUrl + "kxorders/oderPayment/chinaumsNotify/", //扫码回调 
      // 'chinaumsNotify' : "http://cyq.ittun.com/kxorders/oderPayment/chinaumsSendBillQRCode/", //扫码回调 
      "updateOrderInfo" : baseUrl + "kxorders/newOrder/updateOrderInfo",    // 修改订单信息


    //银行账户
    'createBankAccount' : baseUrl + "kxuser/bankAccount/createBankAccount.do/",  // 添加银行账户
    'updateBankAccount' : baseUrl + "kxuser/bankAccount/updateBankAccount.do/",  // 修改银行账户
    'setDefaultBankAccount' : baseUrl + "kxuser/bankAccount/updateBankAccount.do/",  // 设置默认银行账户
    'getBankAccount' : baseUrl + "kxuser/bankAccount/getBankAccount.do/",        // 银行账户列表
    'getBankAccountById' : baseUrl + "kxuser/bankAccount/getBankAccountById.do/",    // 查看当前银行账户信息
    'deleteBankAccount' : baseUrl + "kxuser/bankAccount/deleteBankAccount.do/",  // 删除银行账户
    'getCompanyAccountByCompanyId' : baseUrl + "kxuser/bankAccount/getCompanyAccountByCompanyId.do/",  // 获取用户余额
    "bankInfo" : baseUrl + "kxuser/new_role/getPlatformConfiguration",// 银行信息



    // // 取消订单
    // 'homeCloseOrder' : baseUrl + "kxorders/order/close_order",

    // 提现 cash
    'homeGetCashLog' : baseUrl + "cash/get_cash_log",
    'homeAddCashLog' : baseUrl + "cash/add_cash",

    // 无压缩裁剪上传
    'homeAutoUpload' : baseUrl +"auto/auto_upload",
    //专题图上传
    

    /**
     * 公共接口
     * @author hg <www.qingwuit.com>
     */

    // 获取协议数据(根据ename)
    "homeGetAgreementInfo" : baseUrl + "api/get_agreement_info",


    // 获取PC商品分类信息
    "homeGetGoodsClassList" : baseUrl + "api/get_goods_class_list",


    // 前台广告位
    'showAdver' : baseUrl + "kxmarketing/adp/showAdver/",     //广告位

    //专题
    'indexSubject' : baseUrl + "kxgoods/indexGoods/getHomeSpecialGoods",     //首页专题
    'getSpecialGoodsById' : baseUrl + "kxgoods/indexGoods/getSpecialGoodsById",     //专题
    'GoodsComboList' : baseUrl + "kxgoods/goods/GoodsComboList",     //套餐
    'activityCollection' : baseUrl + "kxmarketing/promotion/activityCollection",     //活动集合
    'getGoodsPromByactivityCollection' : baseUrl + "kxmarketing/promotion/getGoodsPromByactivityCollection",     //活动页


    //控销
    'getBoutiqueControl' : baseUrl + "kxgoods/goods/getBoutiqueControl",     //专题

   
    //大厅开票
    'querySupplierHzid' : baseUrl + "kxuser/user/querySupplierHzid",     //专题

    "wx_payCallback" : baseUrl + "kxorders/oderPayment/wx_payCallback", 

    //抽奖
    "frontShowAwards" : baseUrl + "kxmarketing/promotion/frontShowAwards/",  //获取抽奖信息
    "awardWinningUser" : baseUrl + "kxmarketing/promotion/awardWinningUser/",  //当前活动中奖用户   
    "awardWinUserByCompanyId" : baseUrl + "kxmarketing/promotion/awardWinUserByCompanyId",  //中奖纪录
    "luckyDraw" : baseUrl + "kxmarketing/promotion/luckyDraw/",  //执行抽奖
    "luckyDrawResults" : baseUrl + "kxmarketing/promotion/luckyDrawResults",  //抽奖结果
    

    //红包
    "showHongBaoBySubId" : baseUrl + "kxmarketing/promotion/showHongBaoBySubId",  //获取红包信息
    "HongBaoReceiveDetailByUser" : baseUrl + "kxmarketing/promotion/HongBaoReceiveDetailByUser",  //当前用户红包明细
    "HongBaoSend" : baseUrl + "kxmarketing/promotion/HongBaoSend",  //领取红包
    "HongBaoReceiveResults" : baseUrl + "kxmarketing/promotion/HongBaoReceiveResults",  //领取结果
    "getReceiveHBDetection" : baseUrl + "kxmarketing/promotion/getReceiveHBDetection",  //判断用户是否已领取红包 
    "getHongbao" : baseUrl + "kxorders/newOrder/hongbao",  //红包提现
    /**
     * @deprecated 聊天接口
     */

     "chatAddFriend" : baseUrl + "chat/add_friend", // 添加为好友
     "sendChat" : baseUrl + "kxkefu/chat/chat", // 提交信息
     "chatGetChatFriend" : baseUrl + "kxkefu/info/onlineUsers", // 获取聊天客服列表
     "CustomerService" : baseUrl + "kxkefu/info/CustomerService", // 所有客服列表
     "bdService" : baseUrl + "kxkefu/info/admin", // 当前用户绑定客服信息
     "chatGetChatMsg" : baseUrl + "kxkefu/chat/historyRecord", // 获取聊天记录
     "chatChatEvent" : baseUrl + "chat/chat_event", // 接收前端信息接口
     "chatReadMsg" : baseUrl + "chat/read_msg", // 清空未读信息
     "DeleteChat" : baseUrl + "kxkefu/chat/news/delete", // 删除聊天记录
     "RevokeChat" : baseUrl + "kxkefu/chat/news/revoke", // 撤回聊天记录
     "uploadImage" : baseUrl + "kxkefu/chat/uploadImage", // 上传图片
     "uploadFile" : baseUrl + "kxkefu/chat/uploadFile", // 上传附件
}

